import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  showPassword: {
    id: 'portal.views.logistration.button.showPassword.text',
    defaultMessage: 'Show password',
    description: 'Alt text for show password icon',
  },
  hidePassword: {
    id: 'portal.views.logistration.button.hidePassword.text',
    defaultMessage: 'Hide password',
    description: 'Alt text for hide password icon',
  },
});

export default messages;
